var map = {
	"./feature_buy_freespin_cn.png": 1307,
	"./feature_buy_freespin_en.png": 5657,
	"./feature_buy_freespin_id.png": 17831,
	"./feature_buy_freespin_ko.png": 48906,
	"./feature_buy_freespin_ph.png": 47880,
	"./feature_buy_freespin_th.png": 59380,
	"./feature_buy_freespin_zh.png": 73706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68045;